/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputStockItem
 */
export interface OutputStockItem {
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    cameraType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    connectionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputStockItem
     */
    id?: number;
    /**
     * Атрибути дрона (null для боєкомплекту)
     * @type {string}
     * @memberof OutputStockItem
     */
    missionType?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputStockItem
     */
    opticDistanceKm?: number;
    /**
     * 
     * @type {string}
     * @memberof OutputStockItem
     */
    type?: string;
    /**
     * Атрибути боєкомплекту (null для дрона)
     * @type {string}
     * @memberof OutputStockItem
     */
    warheadType?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputStockItem
     */
    weightKg?: number;
}

/**
 * Check if a given object implements the OutputStockItem interface.
 */
export function instanceOfOutputStockItem(value: object): boolean {
    return true;
}

export function OutputStockItemFromJSON(json: any): OutputStockItem {
    return OutputStockItemFromJSONTyped(json, false);
}

export function OutputStockItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputStockItem {
    if (json == null) {
        return json;
    }
    return {
        
        'cameraType': json['cameraType'] == null ? undefined : json['cameraType'],
        'connectionType': json['connectionType'] == null ? undefined : json['connectionType'],
        'description': json['description'] == null ? undefined : json['description'],
        'id': json['id'] == null ? undefined : json['id'],
        'missionType': json['missionType'] == null ? undefined : json['missionType'],
        'name': json['name'] == null ? undefined : json['name'],
        'opticDistanceKm': json['opticDistanceKm'] == null ? undefined : json['opticDistanceKm'],
        'type': json['type'] == null ? undefined : json['type'],
        'warheadType': json['warheadType'] == null ? undefined : json['warheadType'],
        'weightKg': json['weightKg'] == null ? undefined : json['weightKg'],
    };
}

export function OutputStockItemToJSON(value?: OutputStockItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cameraType': value['cameraType'],
        'connectionType': value['connectionType'],
        'description': value['description'],
        'id': value['id'],
        'missionType': value['missionType'],
        'name': value['name'],
        'opticDistanceKm': value['opticDistanceKm'],
        'type': value['type'],
        'warheadType': value['warheadType'],
        'weightKg': value['weightKg'],
    };
}

